<template>
  <div class="password-container">
    <van-form ref="passwordForm">
      <van-field v-model="oldPassword" :type="showOldPassword ? 'text' : 'password'" label="原密码"
        :rules="[{ required: true, message: '请输入原密码' }]" :right-icon="showOldPassword ? 'eye-o' : 'closed-eye'"
        @click-right-icon="showOldPassword = !showOldPassword" />

      <van-field v-model="newPassword" :type="showNewPassword ? 'text' : 'password'" label="新密码"
        :rules="[{ required: true, message: '请输入新密码' }]" :right-icon="showNewPassword ? 'eye-o' : 'closed-eye'"
        @click-right-icon="showNewPassword = !showNewPassword" />

      <van-field v-model="confirmPassword" :type="showConfirmPassword ? 'text' : 'password'" label="确认密码"
        :rules="confirmPasswordRules" :right-icon="showConfirmPassword ? 'eye-o' : 'closed-eye'"
        @click-right-icon="showConfirmPassword = !showConfirmPassword" />
    </van-form>

    <!-- 确认按钮 -->
    <van-button color="var(--mainColor)" round class="confirm-btn" @click="confirm">
      确定
    </van-button>
  </div>
</template>

<script>
import { changePasswordApi } from './api'
const { jumpURL } = projectConfig
export default {
  name: 'ChangePassword',
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      loading: false,
      jumpURL
    }
  },
  computed: {
    confirmPasswordRules() {
      return [
        { required: true, message: '请确认新密码' },
        { validator: this.validateConfirmPassword, message: '两次输入的密码不一致' }
      ]
    },
  },
  methods: {
    // 验证确认密码
    validateConfirmPassword(val) {
      return val === this.newPassword
    },

    // 提交表单
    async confirm() {
      this.loading = true
      changePasswordApi({
        password: this.oldPassword,
        newPassword: this.newPassword,
      }).then(res => {
        if (res.success) {
          this.$dialog.confirm({
            title: '系统提示',
            message: '修改密码成功，建议您重新登录',
          })
            .then(() => {
              localStorage.clear()
              window.location.href = jumpURL + '/mobile/'
            })
            .catch(() => {
              // on cancel
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.password-container {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>